'use client';

import { useEffect, useState } from 'react';

export function EnvBanner() {
  const [env, setEnv] = useState<'dev' | 'qua' | null>(null);

  useEffect(() => {
    const host = window.location.hostname;
    if (host.startsWith('dev.')) setEnv('dev');
    else if (host.startsWith('qua.')) setEnv('qua');
  }, []);

  if (!env) return null;

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 z-50 py-0.5 text-center text-xs font-semibold tracking-widest text-white uppercase pointer-events-none ${
        env === 'dev' ? 'bg-sky-400/60' : 'bg-amber-400/60'
      }`}
    >
      {env}
    </div>
  );
}
